import { LocationTypeFilter } from '@/pages/dashboard/mapping/model/types';

import { LocationFilter } from './location-filter';
import { CorridorControls } from './corridor-controls';
import { TimeMachineToggle } from './time-machine-toggle';

export interface MapControlsProps {
  // Location filter
  locationTypeFilter: LocationTypeFilter;
  locationsCount: number;
  filteredCount: number;
  onLocationTypeToggle: (type: keyof LocationTypeFilter) => void;
  onToggleAllLocationTypes: () => void;

  // Corridors
  showCorridors: boolean;
  corridorType: 'RIT' | 'RIH';
  onToggleCorridors: () => void;
  onCorridorTypeChange: (type: 'RIT' | 'RIH') => void;

  // Time machine
  showTimeMachine: boolean;
  onToggleTimeMachine: () => void;
}

export function MapControls({
  // Location filter props
  locationTypeFilter,
  locationsCount,
  filteredCount,
  onLocationTypeToggle,
  onToggleAllLocationTypes,

  // Corridor props
  showCorridors,
  corridorType,
  onToggleCorridors,
  onCorridorTypeChange,

  // Time machine props
  showTimeMachine,
  onToggleTimeMachine
}: MapControlsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <LocationFilter
        filter={locationTypeFilter}
        totalCount={locationsCount}
        filteredCount={filteredCount}
        onToggle={onLocationTypeToggle}
        onToggleAll={onToggleAllLocationTypes}
      />

      <CorridorControls
        showCorridors={showCorridors}
        corridorType={corridorType}
        isTimeMachineActive={showTimeMachine}
        onToggle={onToggleCorridors}
        onTypeChange={onCorridorTypeChange}
      />

      <TimeMachineToggle isActive={showTimeMachine} onToggle={onToggleTimeMachine} />
    </div>
  );
}

export type { LocationTypeFilter };
